import gql from 'graphql-tag'
const getLanguages = schema => gql`query getLanguages {
    pdt_language {
        code
        description
    }
  }`
export default getLanguages
